<template>
  <li class="carousel-slide">
    <slot :isActive="true"></slot>
  </li>
</template>

<script>
/**
 * Slide for the local <Carousel>. Drop-in replacement for the `vue-carousel`
 * <Slide>. The slide width is driven purely by the `--carousel-per-page` CSS
 * custom property that the parent <Carousel> sets on the track and which is
 * inherited through the DOM — so no provide/inject across the slot boundary is
 * required (that does not work reliably in Vue 2).
 *
 * The `isActive` scoped-slot prop is kept for API compatibility with
 * vue-carousel and is always true: every rendered card is interactive.
 */
export default {
  name: 'Slide',
};
</script>

<style scoped lang="scss">
.carousel-slide {
  box-sizing: border-box;
  display: flex;
  flex: 0 0 calc(100% / var(--carousel-per-page, 1));
  max-width: calc(100% / var(--carousel-per-page, 1));
  justify-content: space-around; /* distribute the card with even space around it */
  list-style: none;

  & > * {
    flex: 0 1 auto;
    min-width: 0;
  }
}
</style>
